import PropTypes from 'prop-types'

import { getContentfulField } from '../../utils/GatsbyUtils'


const Feature = data => ({
  title: data.title,
  description: getContentfulField(data, 'description'),
  icon: data.icon?.file?.url,
})

Feature.propTypes = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
})

Feature.defaultProps = {
  title: '',
  description: '',
  icon: '',
}

export default Feature
